/* @ngInject */
const dispatchCtrl = (
  $scope,
  $$dispatch
) => {
  $scope.$$dispatch = $$dispatch
}

export default dispatchCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/dispatch/dispatch.controller.js